import React, {useContext, useEffect, useState} from "react";
import DiagramPropertyDefinitionContext from "../../../common/DiagramPropertyDefinitionContext";
import ElementPropertyDefinitionContext from "../../../common/ElementPropertyDefinitionContext";
import {CommonTranslationKey} from "../../../pages/main/content/CommonTranslationKey";
import {PropertyFilterDto} from "../../../store/elements/Elements";
import {_transl} from "../../../store/localization/TranslMessasge";
import {CancelButton} from "../../button/CancelButton";
import {SaveButton} from "../../button/SaveButton";
import Dialog from "../../dialogs/Dialog";
import DialogActions from "../../dialogs/DialogActions";
import DialogContent from "../../dialogs/DialogContent";
import DialogTitle from "../../dialogs/DialogTitle";
import Grid from "../../dialogs/Grid";
import SingleSelectField from "../select/SingleSelectField";
import TextField from "../textfield/TextField";
import {PropertyTranslation} from "./PropertyTranslation";

interface PropertyFilterDialogProps {
    open: boolean;
    type: "elements" | "diagrams";
    propertyFilterDto: PropertyFilterDto | undefined;
    onSave: (name: string, value: string) => void;
    onClosed: () => void;
}

export default function PropertyFilterDialog(props: PropertyFilterDialogProps) {
    const {open, type, propertyFilterDto, onSave, onClosed} = props;

    const elementPropertyDefinitionContext = useContext(ElementPropertyDefinitionContext);
    const diagramPropertyDefinitionContext = useContext(DiagramPropertyDefinitionContext);

    const [name, setName] = useState<string | null>(null);
    const [nameErrorMessage, setNameErrorMessage] = useState<string | undefined>();
    const [value, setValue] = useState<string>("");

    const propertyDefinitions = type === "elements" ? elementPropertyDefinitionContext.propertyDefinitions : diagramPropertyDefinitionContext.propertyDefinitions;
    const propertyNames = propertyDefinitions?.map(propertyDefinition => propertyDefinition.name);

    useEffect(() => {
        if (open) {
            if (propertyFilterDto) {
                setName(propertyFilterDto.name);
                setValue(propertyFilterDto.value);
            } else {
                setName("");
                setValue("");
            }
        }
    }, [open, propertyFilterDto]);

    function save() {
        if (isInputValid()) {
            onSave(name ?? "", value);
            close();
        }
    }

    function isInputValid() {
        if (!name) {
            setNameErrorMessage(_transl(CommonTranslationKey.FILL_OUT_THIS_FIELD));
            return false;
        }
        return true;
    }

    function close() {
        setNameErrorMessage(undefined);
        onClosed();
    }

    function updateName(newValue: string | null) {
        setNameErrorMessage(undefined);
        setName(newValue);
    }

    return (
        <React.Fragment>
            {propertyDefinitions &&
                <Dialog open={open}>
                    <DialogTitle title={_transl(PropertyTranslation.TITLE)} onDialogClosed={close}/>
                    <DialogContent>
                        <Grid container>
                            <Grid item xs={12}>
                                <SingleSelectField
                                    id="name-field"
                                    label={_transl(CommonTranslationKey.TITLE)}
                                    value={name}
                                    required={true}
                                    acceptFreeText={false}
                                    errorMessage={nameErrorMessage}
                                    options={propertyNames}
                                    onChange={(newValue) => updateName(newValue)}
                                    getOptionLabel={name => name}
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <TextField id="value-field"
                                           label={_transl(CommonTranslationKey.VALUE)}
                                           value={value}
                                           onChange={(value) => setValue(value)}
                                />
                            </Grid>
                        </Grid>
                    </DialogContent>
                    <DialogActions>
                        <SaveButton onClick={(e) => save()}/>
                        <CancelButton onClick={() => close()}/>
                    </DialogActions>
                </Dialog>}
        </React.Fragment>
    );
}
